import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import { BacklogApiBaseError } from "./BacklogApiBaseError";


export class BacklogApiUnexpectedError extends BacklogApiBaseError {
	constructor(options: { response: BacklogHttpResponse; }) {
		super({
			response: options.response,
			message: "BacklogApiUnexpectedError",
		});
	}
}
